import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{ wishListTags: string[] }>;

export const DispatchSetWishListTags: HandlerType = props => {
    props.dispatch({
        type: "Pages/MyListDetails/SetWishListTags",
        wishListTags: props.parameter.wishListTags,
    });
};

export const chain = [DispatchSetWishListTags];

const setWishListTags = createHandlerChainRunner(chain, "SetWishListTags");
export default setWishListTags;
